import {LoginPayload, UserGenericPayload} from "./user-generic-payload";

export class ReLoginWithTokenPayload extends LoginPayload {
  constructor(username: string, private rememberMe: boolean, private token: string) {
    super(username);
  }

  getPayload(): UserTokenPayload {
    return { username: this.username, token: this.token, rememberMe: this.rememberMe };
  }
}

interface UserTokenPayload extends UserGenericPayload {
  token: string;
}
